module.exports = __webpack_public_path__ + "img/origin-login-success.97fdc1f4.gif";